<script lang="ts">
    export let name:string;
    export let label:string;
    export let options:string[];
    export let value:string;

    import { createEventDispatcher } from 'svelte';

    let htmlNames = [];
    let radioGroupValue = options[0]; // the value of the checked item

    options.forEach((option, index) => {
        let htmlName = option.toLowerCase().replace(/\s/g, '-');
        htmlNames.push(htmlName);
    });


    const dispatch = createEventDispatcher();
    function inputChange() {
        value = this.value
		dispatch('message', {
			text: 'Hello, select change!'
		});
    }


</script>

<div>
    <label class="fine-print" for={name}>{label}</label>
    <select name={name} bind:value={value}  on:input={inputChange}>
        {#each options as option, index}
            <option value={option}>{option}</option>
        {/each}
    </select>
</div>


<style>
    label {
        padding: 0;
    }
    select {
        color: var(--text);
        width: 100%;
        height: 48px;
        border: none;
        background: unset;
        padding-left: 0;
    }
    select:focus {
        outline: 2px solid var(--text);
        animation: focus_color 0.5s ease-in-out 0s infinite alternate
    }
    @keyframes focus_color{ from { outline-color: var(--text); } to { outline-color: var(--background-offset); }  }

</style>